<template>
    <div class="servicelist">
        <div id="filtres"> <!-- Contient l'ensemble des filtres-->
            <p class="subtitle"> Rechercher </p>

            <!-- Bloc correspondant au choix de la catégorie (version web)-->
            <div class="categories">
                <router-link tag="div" :to="{ name: 'list', query: {cat: v} }" class="radio-toolbar" v-for='(k, v) in choices("categorie")' :key="k">
                    <input type="radio" :id="k" name="filtre" :value="v" @change='filterChange(); stats(k)' v-model='cat'>
                    <label :for="k">
                        <img :src="`${publicPath}${imagePath(v)}`" :alt="k">
                        <p>{{k}}</p>
                    </label>
                </router-link>
            </div>

            <!-- Bloc correspondant au choix de la catégorie (version mobile) -->
            <div class="categories_smartphone filter">
                <select @change='filterChange(); changeRoute($event.target.value); stats($event.target.value)' :value='cat'>
                    <option v-for='(k, v) in choices("categorie")' :value='v' :key='v'>{{k}}</option>
                </select>
            </div>


            <!-- Bloc correspondant auw autres critères (version web) -->
            <p class="subtitle"> Affiner ma recherche </p>
            <div class="filters">
                <div class="filter">
                    <p>Où ?</p>
                    <select @change='filterChange()' v-model="loc_filter">
                        <option v-for='(k, v) in choices("localisation")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div class="filter">
                    <p>Je souhaite ?</p>
                    <select @change='filterChange()' v-model="mod_filter">
                        <option value=''>Toutes les initiatives</option>
                        <option v-for='(k, v) in choices("modalite")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>

                <!-- Filtres pour lesquels il n'a pas été souhaité de les afficher -->
                <!--<div class="filter">
                    <p>Public cible</p>
                    <select @change='filterChange()' v-model="pub_filter">
                        <option value=''>Tous</option>
                        <option v-for='(k, v) in choices("public")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>-->
                <!--<div class="filter">
                    <p>Contenu</p>
                    <select @change='filterChange()' v-model="con_filter">
                        <option value=''>Tous</option>
                        <option v-for='(k, v) in choices("type_contenu")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>-->

                <!-- Filtres spécifiques par catégorie -->
                <div v-if='cat==="1"' class="filter">
                    <p>Comment je peux commander ?</p>
                    <select @change='filterChange()' v-model="pai_filter">
                        <option v-for='(k, v) in choices("mode_de_paiement")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div v-if='cat==="1"' class="filter">
                    <p>Type de produits ?</p>
                    <select @change='filterChange()' v-model="pro_filter">
                        <option v-for='(k, v) in choices("type_de_produit")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div v-if='cat==="1"' class="filter">
                    <p>Comment récupérer ?</p>
                    <select @change='filterChange()' v-model="liv_filter">
                        <option value=''>Sur place ou à domicile</option>
                        <option v-for='(k, v) in choices("modalite_de_livraison")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div v-if='cat==="2"' class="filter">
                    <p>Type de contenu ?</p>
                    <select @change='filterChange()' v-model="con_filter">
                        <option value=''>Tous</option>
                        <option v-for='(k, v) in choices("type_contenu")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div v-if='cat==="3"' class="filter">
                    <p>Type de domaine ?</p>
                    <select @change='filterChange()' v-model="sol_filter">
                        <option value=''>Tous</option>
                        <option v-for='(k, v) in choices("type_de_domaine_solidarite")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div v-if='cat==="4"' class="filter">
                    <p>Type de domaine ?</p>
                    <select @change='filterChange()' v-model="sav_filter">
                        <option value=''>Tous</option>
                        <option v-for='(k, v) in choices("type_de_domaine_savoirs")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
            </div>

            <!-- Bloc correspondant auw autres critères (version mobile) -->
            <div class="more_criterium">
                <div class="categories_smartphone_ou filter">
                    <select @change='filterChange()' v-model="loc_filter">
                        <option v-for='(k, v) in choices("localisation")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <div class="categories_smartphone_modalite filter">
                    <select @change='filterChange()' v-model="mod_filter">
                        <option value="" disabled selected>Je souhaite ?</option>
                        <option value=''>Toutes les initiatives</option>
                        <option v-for='(k, v) in choices("modalite")' :value='v' :key='v'>{{k}}</option>
                    </select>
                </div>
                <button class="refine" v-on:click="show_hide()"> + de critères</button>
            </div>

             <!-- Bloc correspondant auw critères spécifiques (version mobile) -->
            <div class="filters_smartphone">
                <div id="other_filters_smartphone">
                    <!--<div class="filter">
                        <p>Public cible</p>
                        <select @change='filterChange()' v-model="pub_filter">
                                <option value=''>Tous</option>
                                <option v-for='(k, v) in choices("public")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>-->
                       <!-- <div class="filter">
                            <p>Contenu</p>
                            <select @change='filterChange()' v-model="con_filter">
                                <option value=''>Tous</option>
                                <option v-for='(k, v) in choices("type_contenu")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>-->
                        <div v-if='cat==="1"' class="filter">
                            <p>Comment je peux commander ?</p>
                            <select @change='filterChange()' v-model="pai_filter">
                                <option v-for='(k, v) in choices("mode_de_paiement")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                        <div v-if='cat==="1"' class="filter">
                            <p>Type de produits ?</p>
                            <select @change='filterChange()' v-model="pro_filter">
                                <option v-for='(k, v) in choices("type_de_produit")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                        <div v-if='cat==="1"' class="filter">
                            <p>Comment récupérer ?</p>
                            <select @change='filterChange()' v-model="liv_filter">
                                <option value=''>Sur place ou à domicile</option>
                                <option v-for='(k, v) in choices("modalite_de_livraison")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                        <div v-if='cat==="2"' class="filter">
                            <p>Type de contenu</p>
                            <select @change='filterChange()' v-model="con_filter">
                                <option value=''>Tous</option>
                                <option v-for='(k, v) in choices("type_contenu")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                        <div v-if='cat==="3"' class="filter">
                            <p>Type de domaine ?</p>
                            <select @change='filterChange()' v-model="sol_filter">
                                <option value=''>Tous</option>
                                <option v-for='(k, v) in choices("type_de_domaine_solidarite")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                        <div v-if='cat==="4"' class="filter">
                            <p>Type de domaine ?</p>
                            <select @change='filterChange()' v-model="sav_filter">
                                <option value=''>Tous</option>
                                <option v-for='(k, v) in choices("type_de_domaine_savoirs")' :value='v' :key='v'>{{k}}</option>
                            </select>
                        </div>
                </div>
            </div>
        </div>

        <!-- <p v-if='filteredServices.length !== 0'>Initiatives {{numFirst}} à {{numLast}} (sur {{filteredServices.length}})</p>
        <p v-else>Aucune initiative trouvée pour les filtres sélectionnés</p>-->

        <!-- Bandeau spécifique en haut des résultats -->
        <div class="archived">
            <p class="archived_texte">La mise à jour des initiatives s’est arrêtée le 06 juillet 2020, Certains liens peuvent par conséquent être obsolètes.</p>
        </div>

        <!--Liste des résultats -->
        <div class="services" id="list_services">
            <Service v-for="s in paginated" :data=s :key="s['id']"/>
        </div>
        <div class="no_result" v-if='filteredServices.length === 0 && page>-1'>
            <p> Pas de résultats pour les filtres sélectionnés </p>
            <!--<a class="spread_search" href="/"> Elargir ma recherche à toute la métropole</a>-->
        </div>

        <!-- Pagination -->
        <div class="navigation">
            <button v-if='page !== maxPage' class="pagination" @click="pageChange(page + 1); stats('PageSuivante')">Afficher plus</button>
            <p>{{numLast}}/{{filteredServices.length}}</p>
        </div>
    </div>
</template>

<script>
import Service from './Service.vue'
import Store from '../utils/store.js'
var _paq = window._paq || [];
const SERVICE_PER_PAGE = 14;
const IMAGE_PATH = {
    "1": "Courses-MangerLocal_1.svg",
    "2": "Scolarité.svg",
    "3": "Emploi.svg",
    "4": "FormationCultureActivPhysique.svg",
    "5": "producers.svg"

};
const ARRONDISSEMENTS = ["32", "33", "34", "35", "36", "37", "38", "39", "40"];
const LYON = "31";
const TOUTES_COMMUNES = "0";

export default {
    name: 'ServiceList',
    components: {
      Service
    },
    props: {
        cat: {
            type: String,
            default: "1"
        }
    },
    data: function() {
        return {
            store: Store,

            mod_filter: "",
            loc_filter: TOUTES_COMMUNES,
            pub_filter: "",
            con_filter: "",
            sav_filter: "",
            sol_filter: "",
            // filtres manger local
            liv_filter: "",
            pai_filter: "1",
            pro_filter: "1",
            page: 0,
            publicPath: process.env.BASE_URL
        }
    },
    computed: {
        numFirst: function() {
            return this.page * SERVICE_PER_PAGE + 1;
        },
        numLast: function() {
            return Math.min((this.page + 1) * SERVICE_PER_PAGE, this.filteredServices.length);
        },
        maxPage: function() {
            return Math.max(0, Math.ceil(this.filteredServices.length / SERVICE_PER_PAGE) - 1);
        },
        paginated: function() {
            return this.filteredServices.slice(0, (this.page + 1) * SERVICE_PER_PAGE);
        },
        filteredServices: function () {
            var services = this.store.services;
            services = services
                .filter((s) => this.f(s, "categorie", this.cat))
                .filter((s) => this.f(s, "modalite", this.mod_filter))
                .filter((s) => this.f_loc(s, this.loc_filter))
                .filter((s) => this.f(s, "public", this.pub_filter))
            if(this.cat === "1") {
                services = services
                    .filter((s) => this.f(s, "modalite_de_livraison", this.liv_filter))
                    .filter((s) => this.f_pa(s, this.pai_filter))
                    .filter((s) => this.f_pro(s, this.pro_filter))
            }
            if(this.cat === "2") {
                services = services.filter((s) => this.f(s, "type_contenu", this.con_filter))
            }
            if(this.cat === "3") {
                services = services.filter((s) => this.f(s, "type_de_domaine_solidarite", this.sol_filter))
            }
            if(this.cat === "4") {
                services = services.filter((s) => this.f(s, "type_de_domaine_savoirs", this.sav_filter))
            }
            return services.sort(this.compareInitiatives);
        }
    },
    methods: {
        choices: function(field) {
            return this.store.metadata["fields"][field]["options"]["choices"];
        },
        f: function(elt, type, value, all="") {
            if(value === all) {
                return true;
            } else {
                if(typeof(elt[type]) === "object") {
                    return elt[type].indexOf(value) !== -1;
                } else {
                    return elt[type] === value;
                }
            }
        },
        f_pro: function(elt, value) {
            if(value === "1") {
                return true;
            } else {
                if(typeof(elt["type_de_produit"]) === "object") {
                    return elt["type_de_produit"].indexOf("1") !== -1 ||
                         elt["type_de_produit"].indexOf(value) !== -1;
                } else {
                    return elt["type_de_produit"] == "1" ||
                        elt["type_de_produit"] == value;
                }
            }
        },
        f_pa: function(elt, value) {
            if(value === "1") {
                return true;
            } else if(value === "5") {  // Équivalent à tous sauf sur place
                if(typeof(elt["mode_de_paiement"]) === "object") {
                    return elt["mode_de_paiement"].indexOf("3") === -1;
                } else {
                    return elt["mode_de_paiement"] !== "3";
                }
            } else if(value === "2" || value == "4") {  // Internet || téléphone
                if(typeof(elt["mode_de_paiement"]) === "object") {
                    return elt["mode_de_paiement"].indexOf("1") !== -1 || // Tous
                        elt["mode_de_paiement"].indexOf("5") !== -1 ||    // Internet ou téléphone
                        elt["mode_de_paiement"].indexOf(value) !== -1;
                } else {
                    return elt["mode_de_paiement"] === "1" ||
                        elt["mode_de_paiement"] === "5" ||
                        elt["mode_de_paiement"] === value;
                }
            } else {
                if(typeof(elt["mode_de_paiement"]) === "object") {
                    return elt["mode_de_paiement"].indexOf("1") !== -1 ||
                        elt["mode_de_paiement"].indexOf(value) !== -1;
                } else {
                    return elt["mode_de_paiement"] === "1" ||
                        elt["mode_de_paiement"] === value;
                }
            }
        },
        f_loc: function(elt, value) {
            if(value === TOUTES_COMMUNES) {
                return true;
            } else {
                let search = [TOUTES_COMMUNES, value];
                if(value === LYON) {
                    search = search.concat(ARRONDISSEMENTS);
                } else if(ARRONDISSEMENTS.indexOf(value) !== -1) {
                    search = search.concat(LYON);
                }
                if(typeof(elt["localisation"]) === "object") {
                    return this.contains(elt["localisation"], search);
                } else {
                    return search.indexOf(elt["localisation"]) !== -1;
                }
            }
        },
        compareInitiatives: function(x, y) {
            const comp = this.compareLocalisation(x, y);
            if(comp === 0) {
                if(x["a_la_une"] === y["a_la_une"]) {
                    return x["modified_on"] < y["modified_on"] ? 1 : -1
                } else {
                    return x["a_la_une"] < y["a_la_une"] ? 1 : -1;
                }
            } else {
                return comp;
            }
        },
        contains: function(array, searchArray) {
            for(const i of array) {
                if(searchArray.indexOf(i) !== -1) {
                    return true;
                }
            }
            return false;
        },
        compareValues: function(x, y) {
            if(x !== -1 && y === -1) {
                return -1;
            } else if (x === -1 && y !== -1){
                return 1
            } else if(x !== -1 && y !== -1) {
                return 0;
            } else if(x === -1 && y === -1) {
                return undefined;
            }
        },
        compareLocalisation: function(x, y) {
            let comp;
            if(this.loc_filter === TOUTES_COMMUNES) {
                comp = this.compareValues(x["localisation"].indexOf(TOUTES_COMMUNES), y["localisation"].indexOf(TOUTES_COMMUNES));
                comp = comp === undefined ? 0 : comp;
            } else if(this.loc_filter === LYON) {
                comp = this.compareValues(x["localisation"].indexOf(LYON), y["localisation"].indexOf(LYON));
                if(comp === undefined) {
                    comp = this.compareValues(this.contains(x["localisation"], ARRONDISSEMENTS) ? 0 : -1, this.contains(y["localisation"], ARRONDISSEMENTS) ? 0 : -1);
                    if(comp === undefined) {
                        comp = this.compareValues(x["localisation"].indexOf(TOUTES_COMMUNES), y["localisation"].indexOf(TOUTES_COMMUNES));
                        comp = comp === undefined ? 0 : comp;
                    }
                }
            } else if(ARRONDISSEMENTS.indexOf(this.loc_filter) !== -1) {
                comp = this.compareValues(this.contains(x["localisation"], ARRONDISSEMENTS) ? 0 : -1, this.contains(y["localisation"], ARRONDISSEMENTS) ? 0 : -1);
                if(comp === undefined) {
                    comp = this.compareValues(x["localisation"].indexOf(LYON), y["localisation"].indexOf(LYON));
                    if(comp === undefined) {
                        comp = this.compareValues(x["localisation"].indexOf(TOUTES_COMMUNES), y["localisation"].indexOf(TOUTES_COMMUNES));
                        comp = comp === undefined ? 0 : comp;
                    }
                }
            } else {
                comp = this.compareValues(x["localisation"].indexOf(this.loc_filter), y["localisation"].indexOf(this.loc_filter));
                if(comp === undefined) {
                    comp = this.compareValues(x["localisation"].indexOf(TOUTES_COMMUNES), y["localisation"].indexOf(TOUTES_COMMUNES));
                    comp = comp === undefined ? 0 : comp;
                }
            }
            return comp;
        },
        filterChange: function() {
            this.page = 0;
        },
        pageChange: function(pageNumber) {
            this.page = pageNumber;
        },
        imagePath: function(id) {
            return IMAGE_PATH[id];
        },
        show_hide() {
          var x = document.getElementById("other_filters_smartphone");
          if (x.style.display === "none") {
            x.style.display = "block";
          } else {
            x.style.display = "none";
          }
        },
        stats: function(actionName) {
            _paq.push(["trackEvent", "Categories", actionName]);
        },
        changeRoute(categorie) {
            if(categorie !== this.cat) {
                const loc = { name: 'list', query: {cat: categorie}};
                this.$router.push(loc);
            }
        }
    }
}



</script>

<style scoped>

.fade-enter-active  {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.navigation{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.servicelist{
    background: var(--almost-white);
    padding: 0.2% 10% 1% 10%;
}

.services {
    margin: 1% 0;
    display: grid;
    grid-gap: 0 4%;
    grid-template-columns: 48% 48%;
    min-height: 0;
}

.subtitle {
    text-align: left;
    font-weight: bold;
    font-size: 1vw;
    margin: 1% 0;
}

[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}


.categories{
    display:grid;
    grid-template-columns: repeat(5, 17%);
    justify-content: center;
}

label {
    background-color: var(--very-light-grey);
}

.categories, .categories p, .categories img{
    cursor:pointer;
}

.categories_smartphone, .filters_smartphone, .categories_smartphone_modalite, .categories_smartphone_ou{
    display: none;
}

.radio-toolbar input[type="radio"] {
  display: none;
}

.radio-toolbar label {
    display: inline-block;
    border: 1px solid var(--light-grey);
    border-radius: 10px;
    position: relative;
    height: 5vw;
    width: 70%;
    padding: 4% 3% 1% 3%;
    font-size:0.84vw;
    cursor: pointer;
}

.radio-toolbar img{
    height: 35%;
}

.radio-toolbar:hover label{
  border: 1px solid var(--medium-red);
  color: var(--medium-red);
}

.radio-toolbar:hover img{
  filter: invert(64%) sepia(95%) saturate(7339%) hue-rotate(341deg) brightness(86%) contrast(118%);
}

.radio-toolbar input[type="radio"]:checked+label {
  background-color: white;
  border: 1px solid var(--medium-red);
  color: var(--medium-red);
}

.radio-toolbar input[type="radio"]:checked+label img{
  filter: invert(64%) sepia(95%) saturate(7339%) hue-rotate(341deg) brightness(86%) contrast(118%);
}

.archived {
  background-color: black;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.archived_texte {
  color: white;
  padding-right: 10px;
  font-size: 1vw;
}

.contact{
  width: 12%;
  font-size: 1vw;
  font-weight: bold;
  background-color: white;
  color: var(--medium-red);
  text-align: center;
  text-decoration: none;
  border-radius: 20px;
  padding: 5px 0 5px 0;
  border: 1px solid var(--medium-red);
}

.spread_search{
  width: 12%;
  font-size: 1vw;
  font-weight: bold;
  background-color: var(--medium-red);
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 20px;
  padding: 5px 2%;
}

.no_result p{
    font-size: 1vw;
}

.filters{
    display: grid;
    grid-gap: 10% 2%;
    grid-template-columns: repeat(5, 18%);
    margin-bottom: 3%;
    width: auto;
}

.filter{
    text-align: left;
}

.filter select{
    background: url(../static/arrow_bottom.svg) no-repeat white;
    background-position: 95% 50%;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 3% 5%;
    width: 100%;
    -moz-appearance:none;
    -webkit-appearance:none;
    appearance:none;
    font-size:0.8vw;
}

.filter p{
    color: var(--dark-grey);
    margin: 0 0 1% 0;
    font-size: 0.8vw;
}

.pagination{
    background-color: white;
    border: 1px solid var(--medium-red);
    color: var(--medium-red);
    border-radius: 30px;
    font-size: 1vw;
    padding: 0.5% 2%;
    margin: 2% 5%;
    cursor: pointer;
    font-weight: bold;
}

.refine{
    display: none;
}

@media (max-width: 600px) {
    .servicelist{
        padding-top: 3%;
    }

    .archived {
      margin-top: 1%;
      padding: 10px;
      display: block;
      justify-content: center;
      width: auto;
    }

    .more_criterium{
        display: flex;
    }

    .archived_texte {
      font-size: 3vw;
      width: 100%;
      position: relative;
      margin: 0 0 3% 0;
    }

    .contact{
      width: 50%;
      font-size: 3vw;
      position: relative;
      display: inline-block;
    }

    .categories_smartphone{
        display: flex;
    }

    .categories_smartphone_ou{
        width: 24%;
        display: flex;
        margin: 0 1%;
    }

    .categories_smartphone_modalite{
        width: 37%;
        display: flex;
        margin: 0 1%;
    }

    .categories_smartphone_ou select{
        background: url(../static/location_white.svg) no-repeat var(--dark-grey);
        background-position: 15% 50%;
        color: white;
        border: none;
        padding-left: 40%;
        height: 9vw;
    }

    .categories_smartphone_modalite select{
        background: url(../static/modalite_white.svg) no-repeat var(--dark-grey);
        background-position: 5% 40%;
        padding-left: 25%;
        color: white;
        border: none;
        height: 9vw;
    }

    .categories, .subtitle, .filters, .filters5 {
        display: none;
    }

    .filter select{
        font-size:3vw;
        width: 100%;
        margin-bottom: 3%;
        height: 10vw;
    }

    .filter p{
        font-size: 3vw;
    }

    .filters_smartphone{
        display: flex;
        margin: 2% 0;
    }

    .refine{
        display: flex;
        background-color: var(--dark-grey);
        color: white;
        text-align: center;
        text-decoration: none;
        border-radius: 20px;
        border: none;
        font-size: 3vw;
        justify-content: center;
        width: 41%;
        height: 10vw;
        align-items: center;
    }

    #other_filters_smartphone{
        display: none;
        width: 100%;
    }
    .contact{
      width: 50%;
      font-size: 3vw;
    }

    .no_result p{
        font-size: 3vw;
    }

    .services {
        margin: 1% 0;
        display: grid;
        grid-gap: 0 4%;
        grid-template-columns: 100%;
        min-height: 0;
    }

    .pagination{
        font-size: 3vw;
        height: 10vw;
        width: 30%;
    }
}
</style>
